export const countries = [
  {
    'iso': 'af',
    'name': 'Afghanistan',
    'phone_code': '93',
    'all_codes': ['93'],
    'offset': 400
  },
  {
    'iso': 'al',
    'name': 'Albania',
    'phone_code': '355',
    'all_codes': ['355'],
    'offset': 1000
  },
  {
    'iso': 'dz',
    'name': 'Algeria',
    'phone_code': '213',
    'all_codes': ['213'],
    'offset': 11800
  },
  {
    'iso': 'as',
    'name': 'American Samoa',
    'phone_code': '1',
    'all_codes': ['1-684'],
    'offset': 2200
  },
  {
    'iso': 'ad',
    'name': 'Andorra',
    'phone_code': '376',
    'all_codes': ['376'],
    'offset': 0
  },
  {
    'iso': 'ao',
    'name': 'Angola',
    'phone_code': '244',
    'all_codes': ['244'],
    'offset': 1600
  },
  {
    'iso': 'ai',
    'name': 'Anguilla',
    'phone_code': '1',
    'all_codes': ['1-264'],
    'offset': 800
  },
  {
    'iso': 'aq',
    'name': 'Antarctica',
    'phone_code': '672',
    'all_codes': ['672'],
    'offset': 1800
  },
  {
    'iso': 'ag',
    'name': 'Antigua and Barbuda',
    'phone_code': '1',
    'all_codes': ['1-268'],
    'offset': 600
  },
  {
    'iso': 'ar',
    'name': 'Argentina',
    'phone_code': '54',
    'all_codes': ['54'],
    'offset': 2000
  },
  {
    'iso': 'am',
    'name': 'Armenia',
    'phone_code': '374',
    'all_codes': ['374'],
    'offset': 1200
  },
  {
    'iso': 'aw',
    'name': 'Aruba',
    'phone_code': '297',
    'all_codes': ['297'],
    'offset': 2800
  },
  {
    'iso': 'au',
    'name': 'Australia',
    'phone_code': '61',
    'all_codes': ['61'],
    'offset': 2600
  },
  {
    'iso': 'at',
    'name': 'Austria',
    'phone_code': '43',
    'all_codes': ['43'],
    'offset': 2400
  },
  {
    'iso': 'az',
    'name': 'Azerbaijan',
    'phone_code': '994',
    'all_codes': ['994'],
    'offset': 3000
  },
  {
    'iso': 'bs',
    'name': 'Bahamas',
    'phone_code': '1',
    'all_codes': ['1-242'],
    'offset': 6000
  },
  {
    'iso': 'bh',
    'name': 'Bahrain',
    'phone_code': '973',
    'all_codes': ['973'],
    'offset': 4400
  },
  {
    'iso': 'bd',
    'name': 'Bangladesh',
    'phone_code': '880',
    'all_codes': ['880'],
    'offset': 3600
  },
  {
    'iso': 'bb',
    'name': 'Barbados',
    'phone_code': '1',
    'all_codes': ['1-246'],
    'offset': 3400
  },
  {
    'iso': 'by',
    'name': 'Belarus',
    'phone_code': '375',
    'all_codes': ['375'],
    'offset': 6600
  },
  {
    'iso': 'be',
    'name': 'Belgium',
    'phone_code': '32',
    'all_codes': ['32'],
    'offset': 3800
  },
  {
    'iso': 'bz',
    'name': 'Belize',
    'phone_code': '501',
    'all_codes': ['501'],
    'offset': 6800
  },
  {
    'iso': 'bj',
    'name': 'Benin',
    'phone_code': '229',
    'all_codes': ['229'],
    'offset': 4800
  },
  {
    'iso': 'bm',
    'name': 'Bermuda',
    'phone_code': '1',
    'all_codes': ['1-441'],
    'offset': 5200
  },
  {
    'iso': 'bt',
    'name': 'Bhutan',
    'phone_code': '975',
    'all_codes': ['975'],
    'offset': 6200
  },
  {
    'iso': 'bo',
    'name': 'Bolivia',
    'phone_code': '591',
    'all_codes': ['591'],
    'offset': 5600
  },
  {
    'iso': 'ba',
    'name': 'Bosnia and Herzegovina',
    'phone_code': '387',
    'all_codes': ['387'],
    'offset': 3200
  },
  {
    'iso': 'bw',
    'name': 'Botswana',
    'phone_code': '267',
    'all_codes': ['267'],
    'offset': 6400
  },
  {
    'iso': 'br',
    'name': 'Brazil',
    'phone_code': '55',
    'all_codes': ['55'],
    'offset': 5800
  },
  {
    'iso': 'io',
    'name': 'British Indian Ocean Territory',
    'phone_code': '246',
    'all_codes': ['246'],
    'offset': 19800
  },
  {
    'iso': 'vg',
    'name': 'British Virgin Islands',
    'phone_code': '1',
    'all_codes': ['1-284'],
    'offset': 45600
  },
  {
    'iso': 'bn',
    'name': 'Brunei',
    'phone_code': '673',
    'all_codes': ['673'],
    'offset': 5400
  },
  {
    'iso': 'bg',
    'name': 'Bulgaria',
    'phone_code': '359',
    'all_codes': ['359'],
    'offset': 4200
  },
  {
    'iso': 'bf',
    'name': 'Burkina Faso',
    'phone_code': '226',
    'all_codes': ['226'],
    'offset': 4000
  },
  {
    'iso': 'bi',
    'name': 'Burundi',
    'phone_code': '257',
    'all_codes': ['257'],
    'offset': 4600
  },
  {
    'iso': 'kh',
    'name': 'Cambodia',
    'phone_code': '855',
    'all_codes': ['855'],
    'offset': 22000
  },
  {
    'iso': 'cm',
    'name': 'Cameroon',
    'phone_code': '237',
    'all_codes': ['237'],
    'offset': 8800
  },
  {
    'iso': 'ca',
    'name': 'Canada',
    'phone_code': '1',
    'all_codes': ['1-368', '1-403', '1-587', '1-780', '1-825', '1-236', '1-250', '1-604', '1-672', '1-778', '1-204', '1-431', '1-584', '1-428', '1-506', '1-709', '1-879', '1-867', '1-782', '1-902', '1-867', '1-226', '1-249', '1-289', '1-343', '1-365', '1-382', '1-387', '1-416', '1-437', '1-519', '1-548', '1-613', '1-647', '1-683', '1-705', '1-742', '1-753', '1-807', '1-905', '1-942', '1-782', '1-902', '1-263', '1-354', '1-367', '1-418', '1-438', '1-450', '1-468', '1-514', '1-579', '1-581', '1-819', '1-873', '1-306', '1-474', '1-639', '1-867'],
    'offset': 7000
  },
  {
    'iso': 'cv',
    'name': 'Cape Verde',
    'phone_code': '238',
    'all_codes': ['238'],
    'offset': 9800
  },
  {
    'iso': 'ky',
    'name': 'Cayman Islands',
    'phone_code': '1',
    'all_codes': ['1-345'],
    'offset': 23400
  },
  {
    'iso': 'cf',
    'name': 'Central African Republic',
    'phone_code': '236',
    'all_codes': ['236'],
    'offset': 7600
  },
  {
    'iso': 'td',
    'name': 'Chad',
    'phone_code': '235',
    'all_codes': ['235'],
    'offset': 41200
  },
  {
    'iso': 'cl',
    'name': 'Chile',
    'phone_code': '56',
    'all_codes': ['56'],
    'offset': 8600
  },
  {
    'iso': 'cn',
    'name': 'China',
    'phone_code': '86',
    'all_codes': ['86'],
    'offset': 9000
  },
  {
    'iso': 'cx',
    'name': 'Christmas Island',
    'phone_code': '61',
    'all_codes': ['61'],
    'offset': 10200
  },
  {
    'iso': 'cc',
    'name': 'Cocos Islands',
    'phone_code': '61',
    'all_codes': ['61'],
    'offset': 7200
  },
  {
    'iso': 'co',
    'name': 'Colombia',
    'phone_code': '57',
    'all_codes': ['57'],
    'offset': 9400
  },
  {
    'iso': 'km',
    'name': 'Comoros',
    'phone_code': '269',
    'all_codes': ['269'],
    'offset': 22400
  },
  {
    'iso': 'ck',
    'name': 'Cook Islands',
    'phone_code': '682',
    'all_codes': ['682'],
    'offset': 8400
  },
  {
    'iso': 'cr',
    'name': 'Costa Rica',
    'phone_code': '506',
    'all_codes': ['506'],
    'offset': 9200
  },
  {
    'iso': 'hr',
    'name': 'Croatia',
    'phone_code': '385',
    'all_codes': ['385'],
    'offset': 18200
  },
  {
    'iso': 'cu',
    'name': 'Cuba',
    'phone_code': '53',
    'all_codes': ['53'],
    'offset': 9600
  },
  {
    'iso': 'cw',
    'name': 'Curacao',
    'phone_code': '599',
    'all_codes': ['599'],
    'offset': 10000
  },
  {
    'iso': 'cy',
    'name': 'Cyprus',
    'phone_code': '357',
    'all_codes': ['357'],
    'offset': 10400
  },
  {
    'iso': 'cz',
    'name': 'Czechia',
    'phone_code': '420',
    'all_codes': ['420'],
    'offset': 10600
  },
  {
    'iso': 'cd',
    'name': 'Democratic Republic of the Congo',
    'phone_code': '243',
    'all_codes': ['243'],
    'offset': 7400
  },
  {
    'iso': 'dk',
    'name': 'Denmark',
    'phone_code': '45',
    'all_codes': ['45'],
    'offset': 11200
  },
  {
    'iso': 'dj',
    'name': 'Djibouti',
    'phone_code': '253',
    'all_codes': ['253'],
    'offset': 11000
  },
  {
    'iso': 'dm',
    'name': 'Dominica',
    'phone_code': '1',
    'all_codes': ['1-767'],
    'offset': 11600
  },
  {
    'iso': 'do',
    'name': 'Dominican Republic',
    'phone_code': '1',
    'all_codes': ['1-809', '1-829', '1-849'],
    'offset': 11400
  },
  {
    'iso': 'tl',
    'name': 'East Timor',
    'phone_code': '670',
    'all_codes': ['670'],
    'offset': 42200
  },
  {
    'iso': 'ec',
    'name': 'Ecuador',
    'phone_code': '593',
    'all_codes': ['593'],
    'offset': 12000
  },
  {
    'iso': 'eg',
    'name': 'Egypt',
    'phone_code': '20',
    'all_codes': ['20'],
    'offset': 12400
  },
  {
    'iso': 'sv',
    'name': 'El Salvador',
    'phone_code': '503',
    'all_codes': ['503'],
    'offset': 40200
  },
  {
    'iso': 'gq',
    'name': 'Equatorial Guinea',
    'phone_code': '240',
    'all_codes': ['240'],
    'offset': 16600
  },
  {
    'iso': 'er',
    'name': 'Eritrea',
    'phone_code': '291',
    'all_codes': ['291'],
    'offset': 12800
  },
  {
    'iso': 'ee',
    'name': 'Estonia',
    'phone_code': '372',
    'all_codes': ['372'],
    'offset': 12200
  },
  {
    'iso': 'sz',
    'name': 'Eswatini',
    'phone_code': '268',
    'all_codes': ['268'],
    'offset': 40800
  },
  {
    'iso': 'et',
    'name': 'Ethiopia',
    'phone_code': '251',
    'all_codes': ['251'],
    'offset': 13200
  },
  {
    'iso': 'fk',
    'name': 'Falkland Islands',
    'phone_code': '500',
    'all_codes': ['500'],
    'offset': 14000
  },
  {
    'iso': 'fo',
    'name': 'Faroe Islands',
    'phone_code': '298',
    'all_codes': ['298'],
    'offset': 13800
  },
  {
    'iso': 'fj',
    'name': 'Fiji',
    'phone_code': '679',
    'all_codes': ['679'],
    'offset': 13600
  },
  {
    'iso': 'fi',
    'name': 'Finland',
    'phone_code': '358',
    'all_codes': ['358'],
    'offset': 13400
  },
  {
    'iso': 'fr',
    'name': 'France',
    'phone_code': '33',
    'all_codes': ['33'],
    'offset': 26800
  },
  {
    'iso': 'pf',
    'name': 'French Polynesia',
    'phone_code': '689',
    'all_codes': ['689'],
    'offset': 33200
  },
  {
    'iso': 'ga',
    'name': 'Gabon',
    'phone_code': '241',
    'all_codes': ['241'],
    'offset': 14400
  },
  {
    'iso': 'gm',
    'name': 'Gambia',
    'phone_code': '220',
    'all_codes': ['220'],
    'offset': 16200
  },
  {
    'iso': 'ge',
    'name': 'Georgia',
    'phone_code': '995',
    'all_codes': ['995'],
    'offset': 15200
  },
  {
    'iso': 'de',
    'name': 'Germany',
    'phone_code': '49',
    'all_codes': ['49'],
    'offset': 10800
  },
  {
    'iso': 'gh',
    'name': 'Ghana',
    'phone_code': '233',
    'all_codes': ['233'],
    'offset': 15600
  },
  {
    'iso': 'gi',
    'name': 'Gibraltar',
    'phone_code': '350',
    'all_codes': ['350'],
    'offset': 15800
  },
  {
    'iso': 'gr',
    'name': 'Greece',
    'phone_code': '30',
    'all_codes': ['30'],
    'offset': 16800
  },
  {
    'iso': 'gl',
    'name': 'Greenland',
    'phone_code': '299',
    'all_codes': ['299'],
    'offset': 16000
  },
  {
    'iso': 'gd',
    'name': 'Grenada',
    'phone_code': '1',
    'all_codes': ['1-473'],
    'offset': 15000
  },
  {
    'iso': 'gu',
    'name': 'Guam',
    'phone_code': '1',
    'all_codes': ['1-671'],
    'offset': 17200
  },
  {
    'iso': 'gt',
    'name': 'Guatemala',
    'phone_code': '502',
    'all_codes': ['502'],
    'offset': 17000
  },
  {
    'iso': 'gg',
    'name': 'Guernsey',
    'phone_code': '44',
    'all_codes': ['44-1481'],
    'offset': 15400
  },
  {
    'iso': 'gn',
    'name': 'Guinea',
    'phone_code': '224',
    'all_codes': ['224'],
    'offset': 16400
  },
  {
    'iso': 'gw',
    'name': 'Guinea-Bissau',
    'phone_code': '245',
    'all_codes': ['245'],
    'offset': 17400
  },
  {
    'iso': 'gy',
    'name': 'Guyana',
    'phone_code': '592',
    'all_codes': ['592'],
    'offset': 17600
  },
  {
    'iso': 'ht',
    'name': 'Haiti',
    'phone_code': '509',
    'all_codes': ['509'],
    'offset': 18400
  },
  {
    'iso': 'hn',
    'name': 'Honduras',
    'phone_code': '504',
    'all_codes': ['504'],
    'offset': 18000
  },
  {
    'iso': 'hk',
    'name': 'Hong Kong',
    'phone_code': '852',
    'all_codes': ['852'],
    'offset': 17800
  },
  {
    'iso': 'hu',
    'name': 'Hungary',
    'phone_code': '36',
    'all_codes': ['36'],
    'offset': 18800
  },
  {
    'iso': 'is',
    'name': 'Iceland',
    'phone_code': '354',
    'all_codes': ['354'],
    'offset': 20400
  },
  {
    'iso': 'in',
    'name': 'India',
    'phone_code': '91',
    'all_codes': ['91'],
    'offset': 19400
  },
  {
    'iso': 'id',
    'name': 'Indonesia',
    'phone_code': '62',
    'all_codes': ['62'],
    'offset': 18600
  },
  {
    'iso': 'ir',
    'name': 'Iran',
    'phone_code': '98',
    'all_codes': ['98'],
    'offset': 20200
  },
  {
    'iso': 'iq',
    'name': 'Iraq',
    'phone_code': '964',
    'all_codes': ['964'],
    'offset': 20000
  },
  {
    'iso': 'ie',
    'name': 'Ireland',
    'phone_code': '353',
    'all_codes': ['353'],
    'offset': 19000
  },
  {
    'iso': 'im',
    'name': 'Isle of Man',
    'phone_code': '44',
    'all_codes': ['44-1624'],
    'offset': 19600
  },
  {
    'iso': 'il',
    'name': 'Israel',
    'phone_code': '972',
    'all_codes': ['972'],
    'offset': 19200
  },
  {
    'iso': 'it',
    'name': 'Italy',
    'phone_code': '39',
    'all_codes': ['39'],
    'offset': 20600
  },
  {
    'iso': 'ci',
    'name': 'Ivory Coast',
    'phone_code': '225',
    'all_codes': ['225'],
    'offset': 8200
  },
  {
    'iso': 'jm',
    'name': 'Jamaica',
    'phone_code': '1',
    'all_codes': ['1-876'],
    'offset': 21000
  },
  {
    'iso': 'jp',
    'name': 'Japan',
    'phone_code': '81',
    'all_codes': ['81'],
    'offset': 21400
  },
  {
    'iso': 'je',
    'name': 'Jersey',
    'phone_code': '44',
    'all_codes': ['44-1534'],
    'offset': 20800
  },
  {
    'iso': 'jo',
    'name': 'Jordan',
    'phone_code': '962',
    'all_codes': ['962'],
    'offset': 21200
  },
  {
    'iso': 'kz',
    'name': 'Kazakhstan',
    'phone_code': '7',
    'all_codes': ['7'],
    'offset': 23600
  },
  {
    'iso': 'ke',
    'name': 'Kenya',
    'phone_code': '254',
    'all_codes': ['254'],
    'offset': 21600
  },
  {
    'iso': 'ki',
    'name': 'Kiribati',
    'phone_code': '686',
    'all_codes': ['686'],
    'offset': 22200
  },
  {
    'iso': 'xk',
    'name': 'Kosovo',
    'phone_code': '383',
    'all_codes': ['383'],
    'offset': 46800
  },
  {
    'iso': 'kw',
    'name': 'Kuwait',
    'phone_code': '965',
    'all_codes': ['965'],
    'offset': 23200
  },
  {
    'iso': 'kg',
    'name': 'Kyrgyzstan',
    'phone_code': '996',
    'all_codes': ['996'],
    'offset': 21800
  },
  {
    'iso': 'la',
    'name': 'Laos',
    'phone_code': '856',
    'all_codes': ['856'],
    'offset': 23800
  },
  {
    'iso': 'lv',
    'name': 'Latvia',
    'phone_code': '371',
    'all_codes': ['371'],
    'offset': 25600
  },
  {
    'iso': 'lb',
    'name': 'Lebanon',
    'phone_code': '961',
    'all_codes': ['961'],
    'offset': 24000
  },
  {
    'iso': 'ls',
    'name': 'Lesotho',
    'phone_code': '266',
    'all_codes': ['266'],
    'offset': 25000
  },
  {
    'iso': 'lr',
    'name': 'Liberia',
    'phone_code': '231',
    'all_codes': ['231'],
    'offset': 24800
  },
  {
    'iso': 'ly',
    'name': 'Libya',
    'phone_code': '218',
    'all_codes': ['218'],
    'offset': 25800
  },
  {
    'iso': 'li',
    'name': 'Liechtenstein',
    'phone_code': '423',
    'all_codes': ['423'],
    'offset': 24400
  },
  {
    'iso': 'lt',
    'name': 'Lithuania',
    'phone_code': '370',
    'all_codes': ['370'],
    'offset': 25200
  },
  {
    'iso': 'lu',
    'name': 'Luxembourg',
    'phone_code': '352',
    'all_codes': ['352'],
    'offset': 25400
  },
  {
    'iso': 'mo',
    'name': 'Macau',
    'phone_code': '853',
    'all_codes': ['853'],
    'offset': 28200
  },
  {
    'iso': 'mg',
    'name': 'Madagascar',
    'phone_code': '261',
    'all_codes': ['261'],
    'offset': 27000
  },
  {
    'iso': 'mw',
    'name': 'Malawi',
    'phone_code': '265',
    'all_codes': ['265'],
    'offset': 29600
  },
  {
    'iso': 'my',
    'name': 'Malaysia',
    'phone_code': '60',
    'all_codes': ['60'],
    'offset': 30000
  },
  {
    'iso': 'mv',
    'name': 'Maldives',
    'phone_code': '960',
    'all_codes': ['960'],
    'offset': 29400
  },
  {
    'iso': 'ml',
    'name': 'Mali',
    'phone_code': '223',
    'all_codes': ['223'],
    'offset': 27600
  },
  {
    'iso': 'mt',
    'name': 'Malta',
    'phone_code': '356',
    'all_codes': ['356'],
    'offset': 29000
  },
  {
    'iso': 'mh',
    'name': 'Marshall Islands',
    'phone_code': '692',
    'all_codes': ['692'],
    'offset': 27200
  },
  {
    'iso': 'mr',
    'name': 'Mauritania',
    'phone_code': '222',
    'all_codes': ['222'],
    'offset': 28600
  },
  {
    'iso': 'mu',
    'name': 'Mauritius',
    'phone_code': '230',
    'all_codes': ['230'],
    'offset': 29200
  },
  {
    'iso': 'yt',
    'name': 'Mayotte',
    'phone_code': '262',
    'all_codes': ['262'],
    'offset': 26800
  },
  {
    'iso': 'mx',
    'name': 'Mexico',
    'phone_code': '52',
    'all_codes': ['52'],
    'offset': 29800
  },
  {
    'iso': 'fm',
    'name': 'Micronesia',
    'phone_code': '691',
    'all_codes': ['691'],
    'offset': 14200
  },
  {
    'iso': 'md',
    'name': 'Moldova',
    'phone_code': '373',
    'all_codes': ['373'],
    'offset': 26400
  },
  {
    'iso': 'mc',
    'name': 'Monaco',
    'phone_code': '377',
    'all_codes': ['377'],
    'offset': 26200
  },
  {
    'iso': 'mn',
    'name': 'Mongolia',
    'phone_code': '976',
    'all_codes': ['976'],
    'offset': 28000
  },
  {
    'iso': 'me',
    'name': 'Montenegro',
    'phone_code': '382',
    'all_codes': ['382'],
    'offset': 26600
  },
  {
    'iso': 'ms',
    'name': 'Montserrat',
    'phone_code': '1',
    'all_codes': ['1-664'],
    'offset': 28800
  },
  {
    'iso': 'ma',
    'name': 'Morocco',
    'phone_code': '212',
    'all_codes': ['212'],
    'offset': 26000
  },
  {
    'iso': 'mz',
    'name': 'Mozambique',
    'phone_code': '258',
    'all_codes': ['258'],
    'offset': 30200
  },
  {
    'iso': 'mm',
    'name': 'Myanmar',
    'phone_code': '95',
    'all_codes': ['95'],
    'offset': 27800
  },
  {
    'iso': 'na',
    'name': 'Namibia',
    'phone_code': '264',
    'all_codes': ['264'],
    'offset': 30400
  },
  {
    'iso': 'nr',
    'name': 'Nauru',
    'phone_code': '674',
    'all_codes': ['674'],
    'offset': 32000
  },
  {
    'iso': 'np',
    'name': 'Nepal',
    'phone_code': '977',
    'all_codes': ['977'],
    'offset': 31800
  },
  {
    'iso': 'nl',
    'name': 'Netherlands',
    'phone_code': '31',
    'all_codes': ['31'],
    'offset': 31400
  },
  {
    'iso': 'an',
    'name': 'Netherlands Antilles',
    'phone_code': '599',
    'all_codes': ['599'],
    'offset': 1400
  },
  {
    'iso': 'nc',
    'name': 'New Caledonia',
    'phone_code': '687',
    'all_codes': ['687'],
    /* 'offset': 30600 */
    'offset': 26800
  },
  {
    'iso': 'nz',
    'name': 'New Zealand',
    'phone_code': '64',
    'all_codes': ['64'],
    'offset': 32400
  },
  {
    'iso': 'ni',
    'name': 'Nicaragua',
    'phone_code': '505',
    'all_codes': ['505'],
    'offset': 31200
  },
  {
    'iso': 'ne',
    'name': 'Niger',
    'phone_code': '227',
    'all_codes': ['227'],
    'offset': 30800
  },
  {
    'iso': 'ng',
    'name': 'Nigeria',
    'phone_code': '234',
    'all_codes': ['234'],
    'offset': 31000
  },
  {
    'iso': 'nu',
    'name': 'Niue',
    'phone_code': '683',
    'all_codes': ['683'],
    'offset': 32200
  },
  {
    'iso': 'kp',
    'name': 'North Korea',
    'phone_code': '850',
    'all_codes': ['850'],
    'offset': 22800
  },
  {
    'iso': 'mk',
    'name': 'North Macedonia',
    'phone_code': '389',
    'all_codes': ['389'],
    'offset': 27400
  },
  {
    'iso': 'mp',
    'name': 'Northern Mariana Islands',
    'phone_code': '1',
    'all_codes': ['1-670'],
    'offset': 28400
  },
  {
    'iso': 'no',
    'name': 'Norway',
    'phone_code': '47',
    'all_codes': ['47'],
    'offset': 31600
  },
  {
    'iso': 'om',
    'name': 'Oman',
    'phone_code': '968',
    'all_codes': ['968'],
    'offset': 32600
  },
  {
    'iso': 'pk',
    'name': 'Pakistan',
    'phone_code': '92',
    'all_codes': ['92'],
    'offset': 33800
  },
  {
    'iso': 'pw',
    'name': 'Palau',
    'phone_code': '680',
    'all_codes': ['680'],
    'offset': 35200
  },
  {
    'iso': 'ps',
    'name': 'Palestine',
    'phone_code': '970',
    'all_codes': ['970'],
    'offset': 34800
  },
  {
    'iso': 'pa',
    'name': 'Panama',
    'phone_code': '507',
    'all_codes': ['507'],
    'offset': 32800
  },
  {
    'iso': 'pg',
    'name': 'Papua New Guinea',
    'phone_code': '675',
    'all_codes': ['675'],
    'offset': 33400
  },
  {
    'iso': 'py',
    'name': 'Paraguay',
    'phone_code': '595',
    'all_codes': ['595'],
    'offset': 35400
  },
  {
    'iso': 'pe',
    'name': 'Peru',
    'phone_code': '51',
    'all_codes': ['51'],
    'offset': 33000
  },
  {
    'iso': 'ph',
    'name': 'Philippines',
    'phone_code': '63',
    'all_codes': ['63'],
    'offset': 33600
  },
  {
    'iso': 'pn',
    'name': 'Pitcairn',
    'phone_code': '64',
    'all_codes': ['64'],
    'offset': 34400
  },
  {
    'iso': 'pl',
    'name': 'Poland',
    'phone_code': '48',
    'all_codes': ['48'],
    'offset': 34000
  },
  {
    'iso': 'pt',
    'name': 'Portugal',
    'phone_code': '351',
    'all_codes': ['351'],
    'offset': 35000
  },
  {
    'iso': 'pr',
    'name': 'Puerto Rico',
    'phone_code': '1',
    'all_codes': ['1-787', '1-939'],
    'offset': 34600
  },
  {
    'iso': 'qa',
    'name': 'Qatar',
    'phone_code': '974',
    'all_codes': ['974'],
    'offset': 35600
  },
  {
    'iso': 'cg',
    'name': 'Republic of the Congo',
    'phone_code': '242',
    'all_codes': ['242'],
    'offset': 7800
  },
  {
    'iso': 're',
    'name': 'Reunion',
    'phone_code': '262',
    'all_codes': ['262'],
    'offset': 35800
  },
  {
    'iso': 'ro',
    'name': 'Romania',
    'phone_code': '40',
    'all_codes': ['40'],
    'offset': 36000
  },
  {
    'iso': 'ru',
    'name': 'Russia',
    'phone_code': '7',
    'all_codes': ['7'],
    'offset': 36400
  },
  {
    'iso': 'rw',
    'name': 'Rwanda',
    'phone_code': '250',
    'all_codes': ['250'],
    'offset': 36600
  },
  {
    'iso': 'bl',
    'name': 'Saint Barthelemy',
    'phone_code': '590',
    'all_codes': ['590'],
    'offset': 5000
  },
  {
    'iso': 'sh',
    'name': 'Saint Helena',
    'phone_code': '290',
    'all_codes': ['290'],
    'offset': 38000
  },
  {
    'iso': 'kn',
    'name': 'Saint Kitts and Nevis',
    'phone_code': '1',
    'all_codes': ['1-869'],
    'offset': 22600
  },
  {
    'iso': 'lc',
    'name': 'Saint Lucia',
    'phone_code': '1',
    'all_codes': ['1-758'],
    'offset': 24200
  },
  {
    'iso': 'mf',
    'name': 'Saint Martin',
    'phone_code': '590',
    'all_codes': ['590'],
    'offset': 26800
  },
  {
    'iso': 'pm',
    'name': 'Saint Pierre and Miquelon',
    'phone_code': '508',
    'all_codes': ['508'],
    'offset': 34200
  },
  {
    'iso': 'vc',
    'name': 'Saint Vincent and the Grenadines',
    'phone_code': '1',
    'all_codes': ['1-784'],
    'offset': 45200
  },
  {
    'iso': 'ws',
    'name': 'Samoa',
    'phone_code': '685',
    'all_codes': ['685'],
    'offset': 46600
  },
  {
    'iso': 'sm',
    'name': 'San Marino',
    'phone_code': '378',
    'all_codes': ['378'],
    'offset': 39000
  },
  {
    'iso': 'st',
    'name': 'Sao Tome and Principe',
    'phone_code': '239',
    'all_codes': ['239'],
    'offset': 40000
  },
  {
    'iso': 'sa',
    'name': 'Saudi Arabia',
    'phone_code': '966',
    'all_codes': ['966'],
    'offset': 36800
  },
  {
    'iso': 'sn',
    'name': 'Senegal',
    'phone_code': '221',
    'all_codes': ['221'],
    'offset': 39200
  },
  {
    'iso': 'rs',
    'name': 'Serbia',
    'phone_code': '381',
    'all_codes': ['381'],
    'offset': 36200
  },
  {
    'iso': 'sc',
    'name': 'Seychelles',
    'phone_code': '248',
    'all_codes': ['248'],
    'offset': 37200
  },
  {
    'iso': 'sl',
    'name': 'Sierra Leone',
    'phone_code': '232',
    'all_codes': ['232'],
    'offset': 38800
  },
  {
    'iso': 'sg',
    'name': 'Singapore',
    'phone_code': '65',
    'all_codes': ['65'],
    'offset': 37800
  },
  {
    'iso': 'sx',
    'name': 'Sint Maarten',
    'phone_code': '1',
    'all_codes': ['1-721'],
    'offset': 40400
  },
  {
    'iso': 'sk',
    'name': 'Slovakia',
    'phone_code': '421',
    'all_codes': ['421'],
    'offset': 38600
  },
  {
    'iso': 'si',
    'name': 'Slovenia',
    'phone_code': '386',
    'all_codes': ['386'],
    'offset': 38200
  },
  {
    'iso': 'sb',
    'name': 'Solomon Islands',
    'phone_code': '677',
    'all_codes': ['677'],
    'offset': 37000
  },
  {
    'iso': 'so',
    'name': 'Somalia',
    'phone_code': '252',
    'all_codes': ['252'],
    'offset': 39400
  },
  {
    'iso': 'za',
    'name': 'South Africa',
    'phone_code': '27',
    'all_codes': ['27'],
    'offset': 47200
  },
  {
    'iso': 'kr',
    'name': 'South Korea',
    'phone_code': '82',
    'all_codes': ['82'],
    'offset': 23000
  },
  {
    'iso': 'ss',
    'name': 'South Sudan',
    'phone_code': '211',
    'all_codes': ['211'],
    'offset': 39800
  },
  {
    'iso': 'es',
    'name': 'Spain',
    'phone_code': '34',
    'all_codes': ['34'],
    'offset': 13000
  },
  {
    'iso': 'lk',
    'name': 'Sri Lanka',
    'phone_code': '94',
    'all_codes': ['94'],
    'offset': 24600
  },
  {
    'iso': 'sd',
    'name': 'Sudan',
    'phone_code': '249',
    'all_codes': ['249'],
    'offset': 37400
  },
  {
    'iso': 'sr',
    'name': 'Suriname',
    'phone_code': '597',
    'all_codes': ['597'],
    'offset': 39600
  },
  {
    'iso': 'sj',
    'name': 'Svalbard and Jan Mayen',
    'phone_code': '47',
    'all_codes': ['47'],
    'offset': 38400
  },
  {
    'iso': 'se',
    'name': 'Sweden',
    'phone_code': '46',
    'all_codes': ['46'],
    'offset': 37600
  },
  {
    'iso': 'ch',
    'name': 'Switzerland',
    'phone_code': '41',
    'all_codes': ['41'],
    'offset': 8000
  },
  {
    'iso': 'sy',
    'name': 'Syria',
    'phone_code': '963',
    'all_codes': ['963'],
    'offset': 40600
  },
  {
    'iso': 'tw',
    'name': 'Taiwan',
    'phone_code': '886',
    'all_codes': ['886'],
    'offset': 43600
  },
  {
    'iso': 'tj',
    'name': 'Tajikistan',
    'phone_code': '992',
    'all_codes': ['992'],
    'offset': 41800
  },
  {
    'iso': 'tz',
    'name': 'Tanzania',
    'phone_code': '255',
    'all_codes': ['255'],
    'offset': 43800
  },
  {
    'iso': 'th',
    'name': 'Thailand',
    'phone_code': '66',
    'all_codes': ['66'],
    'offset': 41600
  },
  {
    'iso': 'tg',
    'name': 'Togo',
    'phone_code': '228',
    'all_codes': ['228'],
    'offset': 41400
  },
  {
    'iso': 'tk',
    'name': 'Tokelau',
    'phone_code': '690',
    'all_codes': ['690'],
    'offset': 42000
  },
  {
    'iso': 'to',
    'name': 'Tonga',
    'phone_code': '676',
    'all_codes': ['676'],
    'offset': 42800
  },
  {
    'iso': 'tt',
    'name': 'Trinidad and Tobago',
    'phone_code': '1',
    'all_codes': ['1-868'],
    'offset': 43200
  },
  {
    'iso': 'tn',
    'name': 'Tunisia',
    'phone_code': '216',
    'all_codes': ['216'],
    'offset': 42600
  },
  {
    'iso': 'tr',
    'name': 'Turkey',
    'phone_code': '90',
    'all_codes': ['90'],
    'offset': 43000
  },
  {
    'iso': 'tm',
    'name': 'Turkmenistan',
    'phone_code': '993',
    'all_codes': ['993'],
    'offset': 42400
  },
  {
    'iso': 'tc',
    'name': 'Turks and Caicos Islands',
    'phone_code': '1',
    'all_codes': ['1-649'],
    'offset': 41000
  },
  {
    'iso': 'tv',
    'name': 'Tuvalu',
    'phone_code': '688',
    'all_codes': ['688'],
    'offset': 43400
  },
  {
    'iso': 'vi',
    'name': 'U.S. Virgin Islands',
    'phone_code': '1',
    'all_codes': ['1-340'],
    'offset': 45800
  },
  {
    'iso': 'ug',
    'name': 'Uganda',
    'phone_code': '256',
    'all_codes': ['256'],
    'offset': 44200
  },
  {
    'iso': 'ua',
    'name': 'Ukraine',
    'phone_code': '380',
    'all_codes': ['380'],
    'offset': 44000
  },
  {
    'iso': 'ae',
    'name': 'United Arab Emirates',
    'phone_code': '971',
    'all_codes': ['971'],
    'offset': 200
  },
  {
    'iso': 'gb',
    'name': 'United Kingdom',
    'phone_code': '44',
    'all_codes': ['44'],
    'offset': 14600
  },
  {
    'iso': 'us',
    'name': 'United States',
    'phone_code': '1',
    'all_codes': ['1'],
    'offset': 44400
  },
  {
    'iso': 'uy',
    'name': 'Uruguay',
    'phone_code': '598',
    'all_codes': ['598'],
    'offset': 44600
  },
  {
    'iso': 'uz',
    'name': 'Uzbekistan',
    'phone_code': '998',
    'all_codes': ['998'],
    'offset': 44800
  },
  {
    'iso': 'vu',
    'name': 'Vanuatu',
    'phone_code': '678',
    'all_codes': ['678'],
    'offset': 46200
  },
  {
    'iso': 'va',
    'name': 'Vatican',
    'phone_code': '379',
    'all_codes': ['379'],
    'offset': 45000
  },
  {
    'iso': 've',
    'name': 'Venezuela',
    'phone_code': '58',
    'all_codes': ['58'],
    'offset': 45400
  },
  {
    'iso': 'vn',
    'name': 'Vietnam',
    'phone_code': '84',
    'all_codes': ['84'],
    'offset': 46000
  },
  {
    'iso': 'wf',
    'name': 'Wallis and Futuna',
    'phone_code': '681',
    'all_codes': ['681'],
    'offset': 26800
  },
  {
    'iso': 'eh',
    'name': 'Western Sahara',
    'phone_code': '212',
    'all_codes': ['212'],
    'offset': 12600
  },
  {
    'iso': 'ye',
    'name': 'Yemen',
    'phone_code': '967',
    'all_codes': ['967'],
    'offset': 47000
  },
  {
    'iso': 'zm',
    'name': 'Zambia',
    'phone_code': '260',
    'all_codes': ['260'],
    'offset': 47400
  },
  {
    'iso': 'zw',
    'name': 'Zimbabwe',
    'phone_code': '263',
    'all_codes': ['263'],
    /* 'offset': 47800 */
    'offset': 47600
  }
];
